import { useSearchParams } from 'react-router'

import { OwnNoticeDetailPage } from '~/pages/SplitSupplyPlanDetail/OwnNoticeDetailPage'
import { PartnerNoticeDetailPage } from '~/pages/SplitSupplyPlanDetail/PartnerNoticeDetailPage'

/**
 * 分割供給計画の詳細。 自社の通告値 (通 1 件。 URL は通の識別) と他社の通告値 (登録 1 件。 URL は
 * `receipt=<登録の id>`) は同じ route で、 `receipt` の有無で分ける。 48 コマの表と月全体の表示は共有する。
 */
export const SplitSupplyPlanDetailPage = (): React.ReactElement => {
  const [searchParams] = useSearchParams()
  return searchParams.has('receipt') ? (
    <PartnerNoticeDetailPage />
  ) : (
    <OwnNoticeDetailPage />
  )
}
